var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-autocomplete", {
        attrs: {
          items: _vm.items,
          "item-text": "text",
          "item-value": "id",
          label: _vm.$t("components.ajaxBookingRailSelect.label"),
          "append-icon": "train",
          "error-messages": _vm.validationMessage,
          "menu-props": { value: false }
        },
        on: { focus: _vm.openDialog },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function(data) {
              return [
                _c(
                  "v-chip",
                  {
                    key: JSON.stringify(data.item),
                    attrs: { small: "", selected: data.selected },
                    on: { click: _vm.openDialog }
                  },
                  [_vm._v(" " + _vm._s(data.item.text) + " ")]
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.contextModel,
          callback: function($$v) {
            _vm.contextModel = $$v
          },
          expression: "contextModel"
        }
      }),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "1200px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("span", { staticClass: "headline" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "components.ajaxBookingRailSelect.railBookingList"
                        )
                      )
                    )
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "search",
                          label: _vm.$t("global.search"),
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("booking-rail-data-table", {
                attrs: { search: _vm.search },
                scopedSlots: _vm._u([
                  {
                    key: "action-column",
                    fn: function(item) {
                      return _c(
                        "div",
                        {},
                        [
                          _vm.isWNBUser
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0",
                                  attrs: {
                                    icon: "",
                                    disabled: "",
                                    title: _vm.$t(
                                      "components.ajaxBookingRailSelect.showBookingDetails"
                                    )
                                  }
                                },
                                [_c("v-icon", [_vm._v("remove_red_eye")])],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { "z-index": "500", top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              staticClass: "ma-0",
                                              attrs: {
                                                icon: "",
                                                disabled:
                                                  _vm.$store.getters[
                                                    "Ajax/loading"
                                                  ]
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.assignBooking(
                                                    item.booking
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("mdi-pin")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.ajaxBookingRailSelect.pinBooking"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { "z-index": "500", top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              staticClass: "ma-0",
                                              attrs: {
                                                icon: "",
                                                disabled:
                                                  _vm.$store.getters[
                                                    "Ajax/loading"
                                                  ],
                                                title: _vm.$t(
                                                  "components.ajaxBookingRailSelect.importRoute"
                                                )
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.importRoute(
                                                    item.booking
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("train")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.ajaxBookingRailSelect.importRoute"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }
                  }
                ])
              }),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }